import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png";

import "../styles/HomePage.css";
import "../styles/HomeMobile.css";

export default function DownloadPage() {
  const { t } = useTranslation();

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.hwai.healthaimobile";
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      window.location.href =
        "https://apps.apple.com/us/app/healthw-ai/id6755588655";
    }
  }, []);

  return (
    <>
      <Navbar />

      <div className="container page home-page">
        <section
          className="section hero-section"
          style={{ minHeight: "70vh" }}
        >
          <img
            src={logo}
            alt="Health W AI Logo"
            style={{
              width: 96,
              height: 96,
              marginBottom: 16,
              borderRadius: 20,
            }}
          />

          {/* Brand name stays same */}
          <h1 className="home-text">Health W AI</h1>

          {/* Translated subtitle */}
          <p style={{ marginTop: 12, opacity: 0.85 }}>
            {t("download.subtitle")}
          </p>

          <div
            style={{
              marginTop: 32,
              display: "flex",
              flexDirection: "column",
              gap: 16,
              alignItems: "center",
            }}
          >
            <a
              href="https://apps.apple.com/us/app/healthw-ai/id6755588655"
              className="zoom-button"
              style={{ minWidth: 220, textAlign: "center" }}
            >
              {t("download.appStore")} →
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.hwai.healthaimobile"
              className="zoom-button"
              style={{ minWidth: 220, textAlign: "center" }}
            >
              {t("download.playStore")} →
            </a>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}